import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TabService {
  private tabs = ['primary', 'scheme', 'preview'];
  private activeTabSubject = new BehaviorSubject<string>(this.tabs[0]);
  activeTab$ = this.activeTabSubject.asObservable();

  setActiveTab(tab: string) {
    if (this.tabs.includes(tab)) {
      this.activeTabSubject.next(tab);
    }
  }

  goToNextTab() {
    const currentIndex = this.tabs.indexOf(this.activeTabSubject.value);
    if (currentIndex < this.tabs.length - 1) {
      this.activeTabSubject.next(this.tabs[currentIndex + 1]);
    }
  }

  goToPreviousTab() {
    const currentIndex = this.tabs.indexOf(this.activeTabSubject.value);
    if (currentIndex > 0) {
      this.activeTabSubject.next(this.tabs[currentIndex - 1]);
    }
  }
}
